<template>
  <div v-if="profile" title="Research profile">
    <b-card-text>
      <h4>Author Data</h4>
      <b-container class="pl-0 pr-0" style="border:2px solid;border-color:grey;border-radius:10px; padding-bottom:10px">
        <b-row class="ml-1 mt-2" v-if="profile.name">
          <b-col cols="5" align="right">Name: </b-col><b-col>{{profile.name}}</b-col>
        </b-row>
        <b-row class="ml-1" v-if="profile.affiliations.length>0">
          <b-col cols="5" align="right">Affiliation(s): </b-col><b-col><span v-for="(affiliation, affiliationId) in profile.affiliations">{{affiliation}}<span v-if="affiliationId<profile.affiliations.length-1">, </span></span></b-col>
        </b-row>
        <b-row class="ml-1" v-if="profile.publications.length>0">
          <b-col cols="5" align="right">Number of Publications: </b-col><b-col>{{profile.publications.length}}</b-col>
        </b-row>
        <b-row class="ml-1" v-if="profile.profileSources.length>0">
          <b-col cols="5" align="right">Imported profile from: </b-col><b-col><span v-for="(sourceObj, sourceId) in profile.profileSources"><a v-bind:href="sourceObj.sourceURL" target="_blank">{{sourceObj.sourceName}}</a><span v-if="sourceId<profile.profileSources.length-1">, </span></span></b-col>
        </b-row>
      </b-container>


      <b-alert v-if="profile.analysisTask" variant="warning" show>
        <b>ANALYSIS <b-badge>{{profile.analysisTask.status}}</b-badge>: </b>
        {{completedPublications}} completed /
        {{runningPublications}} running /
        {{pendingPublications}} pending /
        {{errorsPublications}} error
      </b-alert>


      <h4 v-if="selectedPublications.length>0" class="mt-3">Selected Publications</h4>
      <b-container class="pl-0 pr-0" v-for="(pub, pubId) in selectedPublications">
      	<b-row >
        	<b-col cols="8">
          	<b style="font-size:13pt; color:#0A98BE">{{pubId+1}}. <a v-bind:href="pub.urls[0]" target="_blank">{{pub.title}}</a></b>
            <b-badge v-if="pub.analyzed" variant="success" class="ml-2">analyzed</b-badge>
            <b-badge v-else variant="warning" class="ml-2">not yet analyzed</b-badge>
            <br/>
            <span v-for="(author, authorId) in pub.authorNames">
              {{author}}<span v-if="authorId<pub.authorNames.length-1">,</span></span>
            <span v-if="pub.authorNames"> | </span>
            <span v-for="(value, key, index) in usefulPublicationProperties(pub)">
              {{value}}<span v-if="index < Object.keys(usefulPublicationProperties(pub)).length-1"> | </span>
            </span>
          </b-col>
          <b-col v-if="pub.analyzed">
          	<b-badge v-for="concept in pub.concepts" class="ml-1"><b>{{concept}}</b></b-badge>
          </b-col>
        </b-row>
      </b-container>
      <p v-if="selectedPublications.length==0" class="mt-3"><b-icon-exclamation-circle-fill></b-icon-exclamation-circle-fill> You haven't selected any publications. Your profile won't be complete until you select at least one publication. If you want to finish your profile, press the "Update Publications" button.</p>

      <div class="mt-5">
        <b-button type="submit" variant="info" v-on:click.prevent="updatePublications">Update Publications</b-button>
        <!--<b-button type="submit" variant="secondary" class="ml-2" v-on:click.prevent="deleteProfile">Delete Profile</b-button>-->
        <!-- Modal 3 - Delete Profile - message. When "Cancel" is pressed, it returns to the "Author Profile View" page. When "Yes, continue" is pressed, it initiates the process for profile deletion. -->
        <b-button class="ml-2" type="submit" variant="secondary" v-b-modal.deleteProfilePrompt>Delete Profile</b-button>
        <b-modal
          id="deleteProfilePrompt"
          title="Delete Author Profile?"
          cancel-title="Cancel"
          ok-title="Yes, continue"
          @ok="deleteProfile">
          <p>
            Are you sure you want to delete your Author Profile? You will not be able to revert the changes.
          </p>
        </b-modal>
      </div>

    </b-card-text>
  </div>
</template>

<script>
export default {
  name: 'ResearchProfileView',
  props: [ 'profile' ],
  computed: {
    selectedPublications: function() {
      var x = _.orderBy(this.profile.publications, 'year', 'desc');
      return x.filter(function(p) {
        return p.selectedForProfile
      })
    },
    completedPublications: function() {
      if( this.profile && this.profile.analysisTask ) {
        console.log(this.profile.analysisTask.completedPublications.split(';'));
        return this.profile.analysisTask.completedPublications.split(';').length;
      }

      return '0';
    },
    runningPublications: function() {
      if( this.profile && this.profile.analysisTask ) {
        console.log(this.profile.analysisTask.runningPublications.split(';'));

        return this.profile.analysisTask.runningPublications.split(';').length;
      }

      return '0';
    },
    pendingPublications: function() {
      if( this.profile && this.profile.analysisTask ) {
        console.log(this.profile.analysisTask.pendingPublications.split(';'));

        return this.profile.analysisTask.pendingPublications.split(';').length;
      }

      return '0';
    },
    errorsPublications: function() {
      if( this.profile && this.profile.analysisTask ) {
        console.log(this.profile.analysisTask.errorsPublications.split(';'));

        return this.profile.analysisTask.errorsPublications.split(';').length;
      }

      return '0';
    },

  },
  methods: {
    updatePublications () {
       this.$emit('updatePublications', true);
    },
    deleteProfile(){
      var params = {
        "researchProfileId": this.profile.rpid
      }
      this.$store.dispatch('deleteResearchProfile', params)
    },
    usefulPublicationProperties(pub) {
      return Object.keys(pub).filter((key) => key=='venue' || key=='year').
       reduce((pubFiltered, key) => { return Object.assign(pubFiltered, { [key]: pub[key] })}, {});
    }
  }

}
</script>

<style scoped>

</style>
